import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type MailIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const MailIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: MailIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Mail'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        height='16'
        rx='2'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        width='20'
        x='2'
        y='4'
      />
      <path
        d='m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
